<div @slideRight class="homepage-navigaation-pannel" [class.search-panel-design]="searchGeneralLook" *ngIf="showMenu">
    <div class="top-holder">
        <app-user-profile></app-user-profile>
        <div *ngIf="searchGeneralLook && !unika" class="btn btn-small" (click)="mapToggleF()"><img src="assets/img/icon-map.png"
                width="20px" alt="">{{
            'MAP-OPEN-MAP' | translate }}</div>
          <span *ngIf="this.user">
            <div *ngIf="searchGeneralLook && unika && (this.user.roles.editor && this.user.compId === this.compId || this.user.roles.admin)" class="btn-unika" (click)="mapToggleF()">{{
            'MAP-OPEN-MAP' | translate }}</div>
        </span>

    </div>
    <div class="logo-holder">
        <app-gallery [galleryId]="'1'" [section]="compId+'images'" [autoPlay]="false" [showThumbs]="false"
            class="logo-img"></app-gallery>
    </div>
    <div class="search-area" [class.active]="showSearchResults">
        <div class="background-light" (click)="closeSearch()"></div>
        <h4>{{ 'COMP-OUR-PROJECTS' | translate }}</h4>
        <div class="translate-buttons">
            <!-- <div class="translate-buttons" *ngIf="this.showLangButtons"> -->
            <button (click)="translateLocal('en')">
                Eng
            </button>
            <button (click)="translateLocal('he')">
                He
            </button>
        </div>
        <app-search-projects (showSearchResults)="showSearchResultsF($event)" [showProperties]="false"
            [projects]="this.items" [compositeDesign]="this.compositeDesign" [unika]="this.unika"
            [searchGeneralLook]="searchGeneralLook"></app-search-projects>
        <!-- <i *ngIf="searchGeneralLook" class="fa fa-search"></i> -->
        <!-- <input type="text" [(ngModel)]="searchTerm" [placeholder]=" 'COMP-TITLE' | translate "
          class="project-search" (focus)="showResoultBlock()"> -->
        <!-- <div class="clickable-title-holder" (focus)="showResoultBlock()">
            <ul class="row" (focus)="showResoultBlock()">
                    <li class="proj-category-holder" *ngFor="let category of categories" (focus)="showResoultBlock()">
                        <h5 *ngIf="category.title !== 'undefined'">{{ category.title }}</h5>
                        <ul class="list-proj clickable-title">
                            <li *ngFor="let item of category.list | projFilter:searchTerm" (click)='viewItemDetails($event, item)' (focus)="showResoultBlock()">{{ item.title }}</li>
                        </ul>
                    </li>
            </ul>
        </div> -->
    </div>
    <div class="pannel-footer">
        <div class="btn btn-small" (click)="mapToggleF()"><img src="assets/img/icon-map.png" width="20px"
                alt="">{{
            'MAP-OPEN-MAP' | translate }}</div>
    </div>

    <!-- <button (click)=showAllResults(this.compId);>test</button> -->
</div>
<app-gallery [galleryId]="'1'" [section]="compId+'sliderhomeimage'" [autoPlay]="true" [showThumbs]="true" [play]="true"
    [delay]=8000 class="slider-home-page general-slider"></app-gallery>